import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';

import styles from './checkbox.module.css';

const Checkbox = ({
  id, labelTranslationKey, isChecked, onChange, required = false
}) => (
  <div className={styles.checkboxContainer}>
    <input
      type="checkbox"
      id={id}
      checked={isChecked}
      onChange={onChange}
      required={required}
    />
    <label htmlFor={id}>
      <Translate id={labelTranslationKey} />
      {required && <span className={styles.requiredText}> (<Translate id="common.required" />)</span>}
    </label>
  </div>
);

Checkbox.defaultProps = {
  required: false
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  labelTranslationKey: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool
};

export default Checkbox;
